import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommunicateToService {

 constructor(private ws: PostmethodService) { }

  communicateToCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "communicateToMaster");
  }
}
